(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["sapor-sticky-b2b-cta"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const selector = '[data-sticky-b2b-cta]';

    const initialize = (root = document) => {
      const stickyCtas = root.matches?.(selector)
        ? [root]
        : Array.from(root.querySelectorAll(selector));

      stickyCtas.forEach((stickyCta) => {
        if (stickyCta.dataset.stickyB2bCtaInitialized === 'true') return;

        stickyCta.dataset.stickyB2bCtaInitialized = 'true';

        const targetAnchor = stickyCta.getAttribute('href');
        const targetId = targetAnchor && targetAnchor.startsWith('#')
          ? targetAnchor.slice(1)
          : '';
        const target = targetId ? document.getElementById(targetId) : null;
        const trigger = Array.from(document.querySelectorAll('a[href]')).find((link) => {
          return link !== stickyCta && link.getAttribute('href') === targetAnchor;
        });
        let ticking = false;

        const updateVisibility = () => {
          const triggerPassed = trigger
            ? trigger.getBoundingClientRect().bottom < 0
            : window.scrollY > window.innerHeight * 0.5;
          const targetIsNear = target
            ? target.getBoundingClientRect().top < window.innerHeight * 0.85
            : false;

          stickyCta.classList.toggle('is-visible', triggerPassed && !targetIsNear);
          ticking = false;
        };

        const requestUpdate = () => {
          if (ticking) return;
          ticking = true;
          window.requestAnimationFrame(updateVisibility);
        };

        window.addEventListener('scroll', requestUpdate, { passive: true });
        window.addEventListener('resize', requestUpdate);
        updateVisibility();
      });
    };

    initialize();
    document.addEventListener('shopify:section:load', (event) => initialize(event.target));
  })();

  } catch(e) { console.error(e); }
})();
})();
